// Fullscreen API wrapper (รองรับ prefix ของ Safari/WebKit)

// เบราว์เซอร์รองรับ + อนุญาตให้ใช้ fullscreen จริงไหม
// (document.fullscreenEnabled = false เมื่อถูกปิดผ่าน permissions policy / อยู่ใน iframe ที่ไม่อนุญาต / เบราว์เซอร์ไม่รองรับ)
export function isFullscreenSupported() {
  const el = document.documentElement;
  const hasApi = !!(el.requestFullscreen || el.webkitRequestFullscreen);
  const enabled = document.fullscreenEnabled || document.webkitFullscreenEnabled;
  return hasApi && !!enabled;
}

export function isFullscreen() {
  return !!(document.fullscreenElement || document.webkitFullscreenElement);
}

export function enterFullscreen() {
  const el = document.documentElement;
  if (el.requestFullscreen) return el.requestFullscreen();
  if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
}

export function exitFullscreen() {
  if (document.exitFullscreen) return document.exitFullscreen();
  if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
}

export function toggleFullscreen() {
  if (isFullscreen()) return exitFullscreen();
  return enterFullscreen();
}

// listen ทั้ง standard + webkit แล้วคืน cleanup function
export function onFullscreenChange(handler) {
  document.addEventListener('fullscreenchange', handler);
  document.addEventListener('webkitfullscreenchange', handler);
  return () => {
    document.removeEventListener('fullscreenchange', handler);
    document.removeEventListener('webkitfullscreenchange', handler);
  };
}
